import { useState } from "react";
import { Link } from "react-router-dom";

import { initiatives } from "../data/globalResearch.js";
import { ArrowRight, ArrowUpRight, CheckIcon, SectionEyebrow } from "./icons.jsx";

/* ---------------------------------------------------------------------------
 * Compact section used on the Global Research landing page.
 * Light, editorial treatment with an interactive selector.
 * ------------------------------------------------------------------------- */
export default function FlagshipSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = initiatives[activeIndex];
  const ActiveIcon = active.icon;

  return (
    <section id="initiatives" className="relative overflow-hidden bg-[#fffdf9] py-24 md:py-32">
      <div className="pointer-events-none absolute right-0 top-20 h-[520px] w-[520px] rounded-full border border-[#d94b2a]/10" />
      <div className="pointer-events-none absolute right-16 top-36 h-[400px] w-[400px] rounded-full border border-[#d94b2a]/10" />

      <div className="relative mx-auto max-w-[1200px] px-6 lg:px-10">
        <div className="grid gap-9 lg:grid-cols-[1fr_.72fr] lg:items-end">
          <div>
            <SectionEyebrow>What we publish and build</SectionEyebrow>
            <h2 className="mt-6 max-w-3xl font-serif text-3xl leading-[0.97] tracking-[-0.045em] text-[#241d1a] md:text-4xl">
              Flagship publications <span className="text-[#ba3524]">and initiatives.</span>
            </h2>
          </div>
          <p className="max-w-md border-l border-[#df6b51] pl-5 text-[15px] leading-relaxed text-[#665d56]">
            A focused collection of programmes that turn timely research into useful intelligence
            for government, industry and investors.
          </p>
        </div>

        <div className="mt-16 grid gap-10 lg:grid-cols-[minmax(270px,.72fr)_minmax(0,1.28fr)] lg:gap-16">
          <div className="border-t border-[#dcd0c4]" role="tablist" aria-label="Flagship initiatives">
            {initiatives.map((initiative, index) => (
              <button
                key={initiative.title}
                type="button"
                role="tab"
                aria-selected={activeIndex === index}
                aria-controls="initiative-panel"
                onClick={() => setActiveIndex(index)}
                className={`group flex w-full items-center justify-between border-b border-[#dcd0c4] py-5 text-left transition-colors ${
                  activeIndex === index ? "text-[#a72d20]" : "text-[#5e554e] hover:text-[#a72d20]"
                }`}
              >
                <span className="flex items-center gap-4">
                  {/* <span className="font-serif text-lg">{String(index + 1).padStart(2, "0")}</span> */}
                  <span className="text-sm font-bold leading-snug">{initiative.title}</span>
                </span>
                <span
                  className={`grid h-7 w-7 place-items-center rounded-full border transition-all ${
                    activeIndex === index
                      ? "border-[#b83424] bg-[#b83424] text-white"
                      : "border-[#cdbfb3] text-[#7b7068] group-hover:border-[#b83424]"
                  }`}
                >
                  <ArrowUpRight className="h-3.5 w-3.5" />
                </span>
              </button>
            ))}

            {/* <Link
              to="/global-research"
              className="group mt-7 inline-flex items-center gap-3 text-sm font-bold text-[#a52e21]"
            >
              See all initiatives
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link> */}
          </div>

          <article
            id="initiative-panel"
            role="tabpanel"
            className="relative border-t-2 border-[#b83424] pt-8 lg:pt-10"
          >
            <div className="flex items-start justify-between gap-6">
              <h3 className="max-w-2xl font-serif text-2xl leading-[1.02] tracking-[-0.035em] text-[#2b2420] md:text-3xl">
                {active.title}
              </h3>
              <div className="hidden h-20 w-20 shrink-0 place-items-center rounded-full bg-[#f4e4db] text-[#ae3122] sm:grid">
                <ActiveIcon className="h-10 w-10" />
              </div>
            </div>

            <p className="mt-7 max-w-2xl text-[16px] leading-relaxed text-[#675e57]">
              {active.body}
            </p>

            {active.bullets && (
              <ul className="mt-8 grid gap-x-7 gap-y-3 border-y border-[#e1d6cb] py-6 sm:grid-cols-2">
                {active.bullets.map((point) => (
                  <li key={point} className="flex items-start gap-2.5 text-sm leading-snug text-[#514842]">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#c44731]" />
                    {point}
                  </li>
                ))}
              </ul>
            )}

            <Link
              to={active.to}
              className="group mt-7 inline-flex items-center gap-3 text-sm font-bold text-[#a52e21]"
            >
              {active.buttonText}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>

            {/* <div className="pointer-events-none absolute bottom-0 right-0 hidden font-serif text-[170px] leading-[.7] tracking-[-.08em] text-[#f4ede7] lg:block">
              {String(activeIndex + 1).padStart(2, "0")}
            </div> */}
          </article>
        </div>
      </div>
    </section>
  );
}